module.exports = __webpack_public_path__ + "fepro/img/model_bottom.46496954.png";